module.exports = "<app-or-note-header [oractivetab]=\"activetab\"></app-or-note-header>\n"